// ===========================================
// DOMAIN UTILITIES
// ===========================================

/**
 * Check if the current domain is the admin subdomain
 * Supports both production (admin.yourtravel.com) and development (localhost)
 */
export function isAdminDomain(): boolean {
  const hostname = window.location.hostname;

  // Check for admin or dashboard subdomain (production)
  if (hostname.startsWith('admin.') || hostname.startsWith('dashboard.')) {
    return true;
  }

  // Development mode check - look for URL path or env variable
  if (import.meta.env.DEV) {
    // Check if URL starts with /admin
    if (window.location.pathname.startsWith('/admin')) {
      return true;
    }

    // Check for VITE_APP_MODE environment variable
    if (import.meta.env.VITE_APP_MODE === 'admin') {
      return true;
    }
  }

  return false;
}

/**
 * Get the base URL for the current domain type
 */
export function getBaseUrl(): string {
  return isAdminDomain() ? '/admin' : '/';
}

/**
 * Get the app type based on domain
 */
export type AppType = 'public' | 'admin';

export function getAppType(): AppType {
  return isAdminDomain() ? 'admin' : 'public';
}
